import React from 'react';
import FAQ from './FAQ';
import {
    FAQContainer,
    FAQContent,
}
    from './FAQElements';


    const Questions = () => {


    return (
        <FAQContainer id="FAQ">
            <FAQContent>
 			    <FAQ/>
            </FAQContent>
        </FAQContainer>
    );
};

export default Questions;
